import { useNavigate } from 'react-router-dom';
import '../CoursesDetallePage/CoursesDetallePage.css';
import './CursosBouticFundamentosPage.css';

const PDF_URL = '/docs/fundamentos-ortodoncia-hibrida-alineadores.pdf';

const objetivosEspecificos = [
  'Comprender los principios de la ortodoncia híbrida.',
  'Realizar diagnóstico ortodóncico digital en 3D (transversal, sagital, vertical y dentario) y la combinación de los mismos.',
  'Interpretar archivos STL y registros digitales.',
  'Utilizar software especializado para planificación ortodóncica.',
  'Realizar análisis cefalométrico digital.',
  'Comprender los fundamentos biomecánicos del staging en alineadores.',
  'Diferenciar alineadores termoformados y alineadores de impresión directa (DAD).',
  'Comprender el concepto de alineadores con topes fusionados.',
  'Integrar alineadores y aparatología fija en tratamientos híbridos.',
  'Comprender las bases del anclaje esqueletal en ortodoncia.',
  'Incorporar criterios neuromusculares en el diagnóstico y tratamiento.',
];

const dia1Temas = [
  'Introducción a la ortodoncia híbrida',
  'Diagnóstico ortodóncico digital',
  'Análisis de modelos STL',
  'Cefalometría digital con Nemoceph',
  'Planificación digital con Nemocast',
  'Fundamentos biomecánicos del staging',
  'Diferentes estrategias de staging',
  'Workshop práctico con software',
];

const dia2Temas = [
  'Evaluación clínica de pacientes',
  'Diagnóstico clínico integral',
  'Integración alineadores y ortodoncia fija',
  'Biomecánica en alineadores',
  'Alineadores termoformados y alineadores DAD',
  'Sistema de alineadores con topes fusionados',
  'Principios de anclaje esqueletal',
  'Clínica con pacientes',
];

const CursosBouticFundamentosPage = () => {
  const navigate = useNavigate();

  return (
    <div className="course-detail-page">
      <div className="course-detail-breadcrumb">
        <button
          type="button"
          onClick={() => navigate('/cursos-boutic')}
          className="course-detail-breadcrumb-link"
        >
          <i className="fas fa-arrow-left" aria-hidden="true" />
          Volver a Cursos Boutic
        </button>
      </div>

      <section className="course-detail-hero">
        <div className="course-detail-hero-container">
          <div className="course-detail-hero-content">
            <div className="course-detail-image-wrapper">
              <div className="course-detail-image-placeholder">
                <i className="fas fa-graduation-cap" aria-hidden="true" />
              </div>
              <div className="course-detail-badge">Presencial</div>
            </div>

            <div className="course-detail-info">
              <h1 className="course-detail-title">
                FUNDAMENTOS DE ORTODONCIA HÍBRIDA CON ALINEADORES
              </h1>
              <p className="course-detail-subtitle">
                Curso de posgrado · Diagnóstico digital, planificación y clínica · IN-OFFICE
              </p>

              <div className="course-detail-stats">
                <div className="course-detail-stat">
                  <i className="fas fa-calendar-alt" aria-hidden="true" />
                  <div>
                    <span className="course-detail-stat-number">2</span>
                    <span className="course-detail-stat-label">Días presenciales</span>
                  </div>
                </div>
                <div className="course-detail-stat">
                  <i className="fas fa-clock" aria-hidden="true" />
                  <div>
                    <span className="course-detail-stat-number">16</span>
                    <span className="course-detail-stat-label">Horas totales</span>
                  </div>
                </div>
                <div className="course-detail-stat">
                  <i className="fas fa-exchange-alt" aria-hidden="true" />
                  <div>
                    <span className="course-detail-stat-number boutic-stat-word">Dual</span>
                    <span className="course-detail-stat-label">Teoría + clínica</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="course-detail-content">
        <div className="course-detail-main">
          <div className="course-detail-info-section">
            <div className="course-detail-info-header">
              <h2 className="course-detail-info-title">Programa Boutic</h2>
              <div className="course-detail-tags">
                <span className="course-detail-tag">Posgrado</span>
                <span className="course-detail-tag">Híbrido</span>
                <span className="course-detail-tag">Alineadores</span>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Fundamentación</h3>
              <div className="course-detail-description-content">
                <p>
                  La ortodoncia contemporánea requiere integrar el diagnóstico clínico tradicional con
                  herramientas digitales avanzadas y una comprensión profunda de la función neuromuscular del
                  sistema estomatognático.
                </p>
                <p>
                  La ortodoncia híbrida propone combinar diferentes sistemas terapéuticos —incluyendo
                  alineadores, aparatología fija, anclaje esqueletal y expansión maxilar— dentro de una
                  planificación digital tridimensional que permita tratamientos más predecibles y estables.
                </p>
                <p>
                  El curso <em>Fundamentos de Ortodoncia Híbrida</em> introduce al profesional en los
                  principios diagnósticos, biomecánicos y digitales necesarios para la planificación y
                  aplicación clínica de tratamientos ortodóncicos modernos. Se incorpora el uso de software
                  especializado, distintos tipos de alineadores y estrategias avanzadas de staging,
                  integrando conceptos de ortodoncia neuromuscular y anclaje esqueletal.
                </p>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Objetivo general</h3>
              <div className="course-detail-description-content">
                <p>
                  Capacitar al profesional en los fundamentos del diagnóstico, planificación digital y
                  aplicación clínica de la ortodoncia híbrida mediante la integración de alineadores,
                  aparatología fija, planificación digital y anclaje esqueletal.
                </p>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Objetivos específicos</h3>
              <div className="course-detail-description-content">
                <p>Al finalizar el curso el cursante será capaz de:</p>
                <ul className="boutic-prose-list">
                  {objetivosEspecificos.map((t) => (
                    <li key={t}>{t}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Destinatarios</h3>
              <div className="course-detail-description-content">
                <ul className="boutic-prose-list">
                  <li>Odontólogos que desean iniciarse en ortodoncia.</li>
                  <li>Profesionales que realizan ortodoncia en su práctica clínica diaria.</li>
                  <li>Especialistas en ortodoncia que desean incorporar planificación digital y alineadores.</li>
                </ul>
              </div>
            </div>

            <div className="course-detail-features-section">
              <h3 className="course-detail-section-title">Software incluido</h3>
              <div className="course-detail-features-grid boutic-features-software">
                <div className="course-detail-feature boutic-feature-stack">
                  <i className="fas fa-chart-line" aria-hidden="true" />
                  <div>
                    <strong>Nemoceph</strong>
                    <p>Diagnóstico cefalométrico digital.</p>
                  </div>
                </div>
                <div className="course-detail-feature boutic-feature-stack">
                  <i className="fas fa-drafting-compass" aria-hidden="true" />
                  <div>
                    <strong>Nemocast</strong>
                    <p>Planificación digital ortodóncica y diseño del tratamiento.</p>
                  </div>
                </div>
                <div className="course-detail-feature boutic-feature-stack">
                  <i className="fas fa-cube" aria-hidden="true" />
                  <div>
                    <strong>Nemofab</strong>
                    <p>
                      Preparación de archivos para diagnóstico 3D transversal, sagital, ATM, vertical y vía
                      aérea.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Staging en alineadores</h3>
              <div className="course-detail-description-content">
                <p>El curso incluye el estudio y aplicación clínica de diferentes estrategias de staging:</p>
                <ul className="boutic-prose-list">
                  <li>
                    <strong>Staging lineal:</strong> movimientos progresivos y continuos.
                  </li>
                  <li>
                    <strong>Staging secuencial:</strong> movimientos organizados por sectores dentarios.
                  </li>
                  <li>
                    <strong>Staging diferencial:</strong> velocidad de movimiento diferenciada según cada diente.
                  </li>
                  <li>
                    <strong>Staging biomecánico:</strong> planificación basada en principios biomecánicos y
                    control tridimensional.
                  </li>
                  <li>
                    <strong>Staging acelerado (Always Aligners):</strong> protocolo que combina alineadores con
                    auxiliares biomecánicos para optimizar la expresión de fuerzas y la velocidad de
                    movimiento dentario.
                  </li>
                </ul>
                <p>
                  Asimismo se presentarán protocolos de staging del enfoque clínico del curso, aplicados a
                  diferentes situaciones.
                </p>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Sistema de alineadores</h3>
              <div className="course-detail-description-content">
                <h4 className="boutic-inline-heading">Alineadores termoformados</h4>
                <p>
                  Fabricados mediante termoformado sobre modelos impresos. Indicados para alineación inicial,
                  apiñamientos leves a moderados y movimientos dentarios simples, con protocolo de aceleración
                  biomecánica para casos complejos.
                </p>
                <h4 className="boutic-inline-heading">Alineadores DAD (Direct Aligner Design)</h4>
                <p>
                  Impresión 3D directa con resinas biocompatibles: mayor control tridimensional, mejor
                  expresión de fuerzas y tratamiento de movimientos más complejos.
                </p>
                <h4 className="boutic-inline-heading">Alineadores con topes fusionados</h4>
                <p>
                  <strong>Fusion Stop Aligners (Always Aligners System):</strong> elementos de control
                  biomecánico integrados al alineador para mejorar la transmisión de fuerzas y reducir la
                  necesidad de attachments adhesivos. Diseño que considera oclusión, musculatura y ATM dentro
                  del enfoque de ortodoncia neuromuscular.
                </p>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Anclaje esqueletal en ortodoncia híbrida</h3>
              <div className="course-detail-description-content">
                <ul className="boutic-prose-list">
                  <li>Principios biomecánicos del anclaje esqueletal</li>
                  <li>Indicaciones clínicas de microimplantes</li>
                  <li>Integración de microimplantes con alineadores</li>
                  <li>Integración con ortodoncia fija</li>
                </ul>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Programa académico — intensivo (2 días)</h3>
              <div className="boutic-day-split">
                <div className="boutic-day-card">
                  <h4 className="boutic-day-title">Día 1 · Diagnóstico digital y planificación</h4>
                  <ul className="boutic-prose-list compact">
                    {dia1Temas.map((t) => (
                      <li key={t}>{t}</li>
                    ))}
                  </ul>
                </div>
                <div className="boutic-day-card">
                  <h4 className="boutic-day-title">Día 2 · Clínica de ortodoncia híbrida</h4>
                  <ul className="boutic-prose-list compact">
                    {dia2Temas.map((t) => (
                      <li key={t}>{t}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Materiales requeridos</h3>
              <div className="course-detail-description-content">
                <ul className="boutic-prose-list">
                  <li>Computadora portátil personal</li>
                  <li>Software Nemotec instalado (según indicación previa)</li>
                  <li>Mouse externo recomendado</li>
                  <li>Casos clínicos en formato STL (opcional)</li>
                </ul>
              </div>
            </div>

            <div className="course-detail-description-section boutic-muted-panel">
              <h3 className="course-detail-section-title">Programa extendido (referencia)</h3>
              <div className="course-detail-description-content">
                <p>
                  El desarrollo completo de <strong>diagnóstico, planificación y clínica</strong> puede
                  estructurarse en <strong>6 módulos</strong> (cada módulo corresponde a 2 meses), con
                  modalidad de <strong>jornada clínica mensual</strong>. La certificación como{' '}
                  <em>Curso de Posgrado en fundamentos de Ortodoncia Híbrida</em> se otorga a quienes cumplan
                  los requisitos académicos y de asistencia. El detalle módulo a módulo figura en el PDF
                  oficial.
                </p>
              </div>
            </div>

            <div className="course-detail-description-section">
              <h3 className="course-detail-section-title">Equipo docente</h3>
              <div className="course-detail-description-content">
                <p>
                  Coordinación y dictado principal: <strong>Dra. Patricia M. Tarquini</strong>,{' '}
                  <strong>Dra. Marcela Becerra</strong> y <strong>Dra. Marisa Ramírez</strong>, con docentes
                  invitadas en ortodoncia digital, biomecánica y ATM (entre otras: Dra. María Sol Requejo,
                  Especialista Natalia López).
                </p>
                <p>Biografías completas y cronogramas en el documento descargable.</p>
              </div>
            </div>
          </div>
        </div>

        <aside className="course-detail-sidebar">
          <div className="course-detail-purchase-card boutic-sidebar-card">
            <div className="course-detail-price-section boutic-sidebar-intro">
              <p className="boutic-sidebar-kicker">Brochure oficial del programa</p>
              <p className="boutic-sidebar-lead">
                Descargá el PDF con currículum extendido, módulos y equipo docente completo.
              </p>
            </div>
            <div className="course-detail-purchase-actions">
              <a
                className="course-detail-buy-btn"
                href={PDF_URL}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-file-pdf" aria-hidden="true" />
                Descargar programa (PDF)
              </a>
            </div>
            <div className="course-detail-guarantee">
              <i className="fas fa-shield-alt" aria-hidden="true" />
              <span>Documentación actualizada Always Aligners</span>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default CursosBouticFundamentosPage;
